import {RootState} from '../rootReducer';
import {createSelector} from '@reduxjs/toolkit';

export const supportAdminStatus = createSelector(
  [(state: RootState) => state.supportAdmin.isLoading],
  isLoading => isLoading,
);

export const isSendingReplySelector = createSelector(
  [(state: RootState) => state.supportAdmin.isSendingReply],
  isSendingReply => isSendingReply,
);

export const isMarkingAsSpamSelector = createSelector(
  [(state: RootState) => state.supportAdmin.isMarkingAsSpam],
  isMarkingAsSpam => isMarkingAsSpam,
);

export const supportAdminSuccessSelector = createSelector(
  [(state: RootState) => state.supportAdmin.supportAdminSuccess],
  success => success,
);

export const supportAdminFailureSelector = createSelector(
  [(state: RootState) => state.supportAdmin.supportAdminFailure],
  failure => failure,
);

export const supportTicketsDataSelector = createSelector(
  [(state: RootState) => state.supportAdmin.supportTickets?.tickets],
  tickets => tickets || [],
);

export const supportTicketsCurrentPageSelector = createSelector(
  [(state: RootState) => state.supportAdmin.supportTickets?.currentPage],
  currentPage => currentPage ?? 0,
);

export const supportTicketsTotalPagesSelector = createSelector(
  [(state: RootState) => state.supportAdmin.supportTickets?.totalPages],
  totalPages => totalPages ?? 0,
);

export const supportTicketsTotalResultsSelector = createSelector(
  [(state: RootState) => state.supportAdmin.supportTickets?.totalResults],
  totalResults => totalResults ?? 0,
);

export const supportTicketsNextPageSelector = createSelector(
  [(state: RootState) => state.supportAdmin.supportTickets?.nextPage],
  nextPage => nextPage ?? null,
);

